import prepareOptions from '../../prepareOptions';
import { HP, KW } from './values';

export default prepareOptions([
  {
    label: __('fieldOptions.car.powerType.hp'),
    value: HP,
  },
  {
    label: __('fieldOptions.car.powerType.kw'),
    value: KW,
  },
]);
